import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import LanguagesPage from './LanguagesPage';
import withBackSupport from 'components/HOCs/withBackSupport';
import { changeUILanguage } from 'actions/app';
import { UI_LANGUAGES } from 'constants/languages';
import { withTranslation } from 'react-i18next';

const LanguagesPageContainer = props => {
  return <LanguagesPage languages={UI_LANGUAGES} {...props} />;
};

const mapDispatch = {
  changeUILanguage,
};

export default compose(
  withBackSupport,
  withTranslation(),
  connect(
    null,
    mapDispatch,
  ),
)(LanguagesPageContainer);
